<template>
    <div id="projects" class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="col-md-3 cont">
                    <a data-toggle="modal" data-target="#myModal"><img class="image" src="./../assets/01_arrive.jpg" alt=""> 
                        <div class="overlay">
                            <div class="text">
                                ARRIVE HOME
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-3 cont">
                     <a data-toggle="modal" data-target="#myModal2"><img class="image" src="./../assets/02_tilting.jpg" alt="">
                        <div class="overlay">
                            <div class="text">
                                TILTING POINT
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-3 cont">
                     <a data-toggle="modal" data-target="#myModal3"><img class="image" src="./../assets/03_heatball.jpg" alt="">
                        <div class="overlay">
                            <div class="text">
                                HEATBALL
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-3 cont">
                    <a data-toggle="modal" data-target="#myModal4"><img class="image" src="./../assets/04_coors.jpg" alt="">
                        <div class="overlay">
                            <div class="text">
                                COORS LIGHT
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-4 cont">
                     <a data-toggle="modal" data-target="#myModal5"><img class="image" src="./../assets/05_calzada.jpg" alt="">
                        <div class="overlay">
                            <div class="text">
                                CALZADA
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-4 cont">
                     <a data-toggle="modal" data-target="#myModal6"><img class="image" src="./../assets/06_coca.jpg" alt="">
                        <div class="overlay">
                            <div class="text">
                                COCA COLA
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-4 cont">
                     <a data-toggle="modal" data-target="#myModal7"><img class="image" src="./../assets/07_tssi.jpg" alt="">
                        <div class="overlay">
                            <div class="text">
                                TECHNOLOGY SOLUTIONS & SERVICES, INC.
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div id="myModal" class="modal fade" tabindex="-1" role="dialog">
             <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                    <!-- <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            &times;
                      </button>
                     </div> -->
                     <div class="modal-body">
                        <img src="./../assets/1_bc_arrivehome-i.png" width="100%" alt="">
                     </div>
                  </div>
            </div>
        </div>
        <div id="myModal2" class="modal fade" tabindex="-1" role="dialog">
             <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                     <div class="modal-body">
                        <img src="./../assets/2_bc_tilting-i.png" width="100%" alt="">
                     </div>
                  </div>
            </div>
        </div>
        <div id="myModal3" class="modal fade" tabindex="-1" role="dialog">
             <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                     <div class="modal-body">
                        <img src="./../assets/3_bc_heatball-i.png" width="100%" alt="">
                     </div>
                  </div>
            </div>
        </div>
       <div id="myModal4" class="modal fade" tabindex="-1" role="dialog">
             <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                     <div class="modal-body">
                        <img src="./../assets/4_bc_coors-i.png" width="100%" alt="">
                     </div>
                  </div>
            </div>
        </div>
        <div id="myModal5" class="modal fade" tabindex="-1" role="dialog">
             <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                     <div class="modal-body">
                        <img src="./../assets/5_bc_calzada-i.png" width="100%" alt="">
                     </div>
                  </div>
            </div>
        </div>
        <div id="myModal6" class="modal fade" tabindex="-1" role="dialog">
             <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                     <div class="modal-body">
                        <img src="./../assets/6_bc_coca-i.png" width="100%" alt="">
                     </div>
                  </div>
            </div>
        </div>
        <div id="myModal7" class="modal fade" tabindex="-1" role="dialog">
             <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                     <div class="modal-body">
                        <img src="./../assets/7_bc_tssi-i.png" width="100%" alt="">
                     </div>
                  </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.modal {
   background-color: rgba(0,0,0,0.6) !important;
}

.modal-content {
    background-color: rgba(0,0,0,0);
    border: 1px solid rgba(0,0,0,0);
    border-radius: 6px;
    -webkit-box-shadow: 0 3px 9px rgba(0,0,0,0);
    box-shadow: 0 3px 9px rgba(0,0,0,0);
}

.container-fluid, .row, .col-md-12, .col-md-4, .col-md-3{
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
}

.cont{
    position: relative;
}

.cont:hover .overlay{
    opacity: 0.8;
}

.overlay{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: .5s ease;
  background-color: #111;
  cursor: pointer;
}

.image {
  display: block;
  width: 100%;
  height: auto;
}

.text {
  color: white;
  font-size: 30px;
  font-weight: bolder;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

</style>


// WEBPACK FOOTER //
// src/components/projects.vue